import Vue, { ComponentOptions } from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

interface SpaHeadline extends Vue {
    objectName: string;
    objectTitle: string;
    objectSubtitle: string;
    objectCity: string;
    objectLocation: string;
}

const SpaHeadline = {
    name: "SpaHeadline",
    computed: {
        objectName: {
            get(this: SpaHeadline) { return window.location.href.indexOf("liegenschaften") !== -1 ? this.$store.state.details.name : this.$store.state.details.name; },
        },
        objectCity: {
            get(this: SpaHeadline) { return window.location.href.indexOf("liegenschaften") !== -1 ? this.$store.state.details.city : this.$store.state.details.objectCity; },
        },
        objectTitle: {
            get(this: SpaHeadline) { return window.location.href.indexOf("liegenschaften") !== -1 ? this.$store.state.details.headline : this.$store.state.details.objectTitle; },
        },
        objectSubtitle: {
            get(this: SpaHeadline) { return window.location.href.indexOf("liegenschaften") !== -1 ? this.$store.state.details.subtitle : this.$store.state.details.subtitle; },
        },
    },
} as ComponentOptions<SpaHeadline>;

export { SpaHeadline };



// WEBPACK FOOTER //
// ./src/components/spa-headline.ts